// extracted by mini-css-extract-plugin
export default {"productGallery":"CJ-z","inQuickShop":"DJ-z"};